import React from 'react';
import { camelCaseToWords } from '../../services/Utils';
import { HorizontalStack } from '../../styles/Containers';
import { CheckboxGroup } from '../Forms/CheckboxGroup';

export const AssetType = ({ onChange, options, value = [] }) => {
  const optionList = options.map((option, index) => ({
    key: `${index}_${option}`,
    label: camelCaseToWords(option),
    name: option,
    checked: value.includes(option),
  }));

  const handleChange = (newOptions) => {
    const checkedOptions = newOptions
      .filter((option) => option.checked)
      .map((option) => option.name);
    onChange(checkedOptions);
  };

  return (
    <HorizontalStack flex minWidth="300px">
      <CheckboxGroup label="" options={optionList} onChange={handleChange} />
    </HorizontalStack>
  );
};
